export default function BrandsAutoMatchCell({ item, store }) {
  return store.getAutoMatchConfig(item.autoMatchRegExp).rawAutoMatch;
}
